module.exports = __webpack_public_path__ + "static/media/image3.7b2c04b4.JPG";